import { lazy } from 'react'
import { useRoutes, Navigate } from 'react-router-dom'

import { useLayout } from '@hooks/useLayout'
import { getRoutes } from './routes'
import BlankLayout from '@layouts/BlankLayout'

const Error = lazy(() => import('../views/pages/misc/Error'))

const router = () => {
	const { layout } = useLayout()

	const allRoutes = getRoutes(layout)

	const routes = useRoutes([
		{
			path: '/',
			index: true,
			element: <Navigate replace to="/login" />
		},
		{
			path: '*',
			element: <BlankLayout />,
			children: [{ path: '*', element: <Error /> }]
		},
		...allRoutes
	])

	return routes
}

export default router
